module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.bigPlayShow) ? _c('div', {
    staticClass: "bigPlay"
  }, [_c('div', {
    staticClass: "rankTitle"
  }, [_c('i', {
    on: {
      "click": _vm.back
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/goback_1.png")
    }
  })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.songName))])]), _vm._v(" "), _c('div', {
    staticClass: "hand",
    class: {
      'hand2': _vm.imgPause
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "singerImg",
    class: {
      'imgPause': _vm.imgPause, 'imgStart': !_vm.imgPause
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.bigImgUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "lrcBox"
  }, [_c('div', {
    staticClass: "lrc-content",
    style: ({
      'margin-top': _vm.lrcOffset + 'px'
    })
  }, _vm._l((_vm.mysongLrc), function(item, index) {
    return _c('p', {
      class: {
        'isCurrentLrc': item.seconds >= _vm.mycurrentTime, 'disCurrentLrc': item.seconds < _vm.mycurrentTime
      }
    }, [_vm._v("\n\t            " + _vm._s(item.lrcContent))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "rangeBox"
  }, [_c('div', {
    staticClass: "currentTime"
  }, [_vm._v(_vm._s(_vm._f("formatTime")(_vm.mycurrentTime)))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mycurrentTime),
      expression: "mycurrentTime"
    }],
    ref: "myAudio",
    staticClass: "playRange",
    attrs: {
      "type": "range",
      "min": "0",
      "max": _vm.timeLength,
      "step": "1"
    },
    domProps: {
      "value": (_vm.mycurrentTime)
    },
    on: {
      "change": function($event) {
        return _vm.rangeChange($event)
      },
      "__r": function($event) {
        _vm.mycurrentTime = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "allTime"
  }, [_vm._v(_vm._s(_vm._f("formatTime")(_vm.timeLength)))])]), _vm._v(" "), _c('div', {
    staticClass: "ct"
  }, [_c('div', {
    staticClass: "prev",
    on: {
      "click": _vm.prevSong
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "play",
    class: {
      'pause': _vm.isplay
    },
    on: {
      "click": _vm.playorp
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "next",
    on: {
      "click": _vm.nextSong
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "blackBox"
  }), _vm._v(" "), _c('div', {
    staticClass: "bigImg bigImgDown",
    style: ({
      'background-image': 'url(' + _vm.bigImgUrl + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "bigImg",
    style: ({
      'background-image': 'url(' + _vm.bigImgUrl + ')'
    })
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39ad8969"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bigPlay.vue
// module id = 96
// module chunks = 0